<div class="auth">
  <form class="auth-form" name="form" (ngSubmit)="f.form.valid && login()" #f="ngForm" novalidate>
    <h2 class="text-center">Logowanie</h2>

    <label [ngClass]="{ 'has-error': f.submitted && !username.valid }">
      LOGIN:
      <input type="text" class="text-center" name="login" [(ngModel)]="model.username" #username="ngModel" required>
    </label>

    <label [ngClass]="{ 'has-error': f.submitted && !password.valid }">
      HASŁO:
      <input type="password" class="text-center" name="password" [(ngModel)]="model.password" #password="ngModel" required>
    </label>

    <a style="float: left;" routerLink="/">Powrót do menu</a>
    <a routerLink="/passwd">Zapomniałeś hasło?</a>

    <button [disabled]="loading" class="text-center">Zaloguj</button>
  </form>
</div>
